/**
 * EL ARRANQUE DEL MODO SIN CONEXIÓN: lo que tiene que estar puesto ANTES de
 * pintar nada (lo llama `main.tsx`).
 *
 *   · la red sin conexión (`redOffline`) y la foto del mapa (`teselasOffline`);
 *   · la escucha de «hay / no hay red» del sistema;
 *   · DE QUIÉN se guarda y se lee: el usuario de la sesión guardada en el
 *     aparato. Se sabe sin esperar a nadie —sin red, la biblioteca de Supabase
 *     tarda hasta ~50 s en contestar con el token caducado—, así que lo primero
 *     que pida la app ya se puede contestar desde el teléfono.
 */
import { escucharRedDelSistema, fijarModoActivo, fijarUsuarioOffline } from "./estadoOffline";
import { modoGuardado } from "./interruptorOffline";
import { instalarRedOffline } from "./redOffline";
import { instalarTeselasOffline } from "./teselasOffline";
import { sesionGuardada } from "./sesionGuardada";

export { sesionGuardada, type SesionGuardada } from "./sesionGuardada";

let arrancado = false;

export function arrancarOffline(): void {
  if (arrancado) return;
  arrancado = true;
  try {
    escucharRedDelSistema();
    const uid = sesionGuardada()?.user.id ?? null;
    if (uid) fijarUsuarioOffline(uid);
    /* El interruptor de la empresa, tal como se supo la última vez (sin red no se
       puede preguntar). Apagado, todo lo de abajo queda instalado pero no hace nada. */
    fijarModoActivo(modoGuardado(uid));
    instalarRedOffline();
    instalarTeselasOffline();
  } catch (e) {
    // El modo sin conexión nunca puede impedir que la app arranque.
    console.warn("[offline] no se pudo arrancar", e);
  }
}
